angular.module('core')
    .factory('TableSelection', function () {
        const create = (items, onChange) => {
            const selection = {
                items: [],
                selected: [],
                setItems: newItems => {
                    selection.items.forEach(item => {
                        if (item) {
                            delete item.selected
                        }
                    })
                    selection.items = angular.isArray(newItems) ? newItems : []
                    return selection.selectNone()
                },
                refresh: () => {
                    selection.selected = selection.items.filter(item => item && item.selected === true)
                    if (angular.isFunction(onChange)) {
                        onChange(selection.selected)
                    }
                    return selection.selected
                },
                toggle: item => {
                    if (item) {
                        item.selected = item.selected !== true
                    }
                    return selection.refresh()
                },
                selectAll: () => {
                    selection.items.forEach(item => {
                        if (item) {
                            item.selected = true
                        }
                    })
                    return selection.refresh()
                },
                selectNone: () => {
                    selection.items.forEach(item => {
                        if (item) {
                            delete item.selected
                        }
                    })
                    return selection.refresh()
                },
                hasSelected: () => selection.selected.length > 0,
                hasAllSelected: () => selection.items.length > 0 && selection.selected.length === selection.items.length,
                hasPartialSelection: () => selection.selected.length > 0 && selection.selected.length < selection.items.length,
                toggleAll: () => selection.hasAllSelected() ? selection.selectNone() : selection.selectAll()
            }
            selection.setItems(items)
            return selection
        }

        return {create: create}
    })
    .component('tableSelectionHeaderCheckbox', {
        bindings: {
            selection: '<'
        },
        template: '<input type="checkbox" class="table-selection-checkbox" ng-disabled="!$ctrl.hasItems()" title="{{ $ctrl.labelKey() | translate }}" aria-label="{{ $ctrl.labelKey() | translate }}" ng-click="$event.stopPropagation(); $ctrl.toggleAll()"/>',
        controller: function ($element) {
            this.hasItems = () => this.selection && this.selection.items.length > 0
            this.hasAllSelected = () => this.selection && this.selection.hasAllSelected()
            this.labelKey = () => this.hasAllSelected() ? 'select.deselectAll' : 'select.all'
            this.toggleAll = () => this.selection && this.selection.toggleAll()
            this.$doCheck = () => {
                const checkbox = $element.find('input')[0]
                if (checkbox && this.selection) {
                    checkbox.checked = this.hasAllSelected()
                    checkbox.indeterminate = this.selection.hasPartialSelection()
                }
            }
        }
    })
    .component('tableSelectionCheckbox', {
        bindings: {
            item: '<',
            selection: '<'
        },
        template: '<input type="checkbox" class="table-selection-checkbox" title="{{ \'select.one\' | translate }}" ng-model="$ctrl.item.selected" ng-click="$event.stopPropagation()" ng-change="$ctrl.selection.refresh()"/>'
    })
